import API from '../../../../../services/api';

export const AVISOS_PROV_API = {
    get: async (page, startDate, endDate, type = null, proveedorId = null) => {
        return API.get(
            `/avisos-proveedor?page=${page}&startDate=${startDate}&endDate=${endDate}${type ? `&search=${type}` : ''}${proveedorId ? `&proveedor_id=${proveedorId}` : ''}`
        ).then(res => res.data);
    },
    blockAllPartTypes: async(tipo) => {
        return API.post('/avisos-proveedor/bloquear-todos', tipo).then(res => res.data);
    }
}